import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { BONOS } from '../data/content';
export function Bonos() {
  return <section className="w-full bg-sage-deep py-20 text-cream sm:py-24" data-id="element-17" data-mp="2haguhwtzhe40">
      <div className="mx-auto max-w-6xl px-5" data-id="element-18" data-mp="2lclqh27wmmtt">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-19" data-mp="2q4my2au4npdi">
          <p className="text-sm font-semibold uppercase tracking-widest text-cream/70" data-id="element-20" data-mp="2q66dy0bvfyer">
            Incluidos gratis
          </p>
          <h2 className="mt-3 font-serif text-3xl font-semibold sm:text-4xl" data-id="element-21" data-mp="3032nm9diaqkw">
            5 Bonos Estratégicos
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-cream/80" data-id="element-22" data-mp="351w3u9k6gvor">
            Recursos extra para planificar mejor, guiar con más claridad y mostrar una
            propuesta más profesional.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-23" data-mp="1apfydaz7hlky">
          {BONOS.map((bono, i) => <Reveal key={bono.tag} delay={i % 3 * 0.08} className="flex flex-col rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur-sm" data-id="element-24" data-mp="1epzz0oizn7bu" data-mpi={i}>
              <div className="mb-4 flex items-center justify-between" data-id="element-25" data-mp="39b7ubj02xug9">
                <span className="inline-flex items-center gap-2 rounded-full bg-clay px-3 py-1 text-xs font-semibold uppercase tracking-wider text-cream" data-id="element-26" data-mp="34ezlsoge0zi2">
                  <GiftIcon className="h-3.5 w-3.5" data-id="element-27" data-mp="x7m0nw0fb9b" />
                  {bono.tag}
                </span>
              </div>
              <h3 className="font-serif text-xl font-semibold leading-tight" data-id="element-28" data-mp="3s3itb1rm5893">{bono.title}</h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-cream/75" data-id="element-29" data-mp="3n3wfor7vhpzr">
                {bono.description}
              </p>
              <div className="mt-5 border-t border-white/10 pt-4 text-sm" data-id="element-30" data-mp="3i52z2pxahivd">
                <span className="text-cream/60 line-through" data-id="element-31" data-mp="2bqlk9yq3bl1r">Valor: {bono.value}</span>
                <span className="ml-2 font-semibold text-clay" data-id="element-32" data-mp="26q69nex70rnh">· Gratis</span>
              </div>
            </Reveal>)}

          <Reveal delay={0.16} className="flex flex-col items-center justify-center rounded-2xl border-2 border-dashed border-cream/25 bg-white/5 p-6 text-center" data-id="element-33" data-mp="yricds6c64u7">
            <p className="text-sm uppercase tracking-widest text-cream/70" data-id="element-34" data-mp="osayn3vow86k">
              Valor total de los 5 bonos
            </p>
            <p className="mt-2 font-serif text-4xl font-semibold text-clay" data-id="element-35" data-mp="ttqm12lcaqs4">$56.000</p>
            <p className="mt-3 text-sm leading-relaxed text-cream/80" data-id="element-36" data-mp="f0wuujwpgm7m">
              Hoy incluidos gratis con Yoga 360.
            </p>
          </Reveal>
        </div>
      </div>
    </section>;
}